import type { JSX } from "react";

export interface JSONViewProps {
  data: unknown;
}

export function JSONView(props: JSONViewProps): JSX.Element {
  const { data } = props;

  return (
    <pre>
      <code>{JSON.stringify(data, null, 2)}</code>
    </pre>
  );
}
